
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/rEditor/rootComps/editorView/bodyStylesSetter.scss.css.virtualfile';
        module.exports = {};